import {getRenaissanceKeepaliveIntervalId} from '@freckle/educator-entities/ts/common/helpers/renaissance-keepalive'
import {deleteSessionCookie} from '@freckle/classroom/ts/api/session'
import {displayNotification} from '@freckle/classroom/ts/common/helpers/helpers'
import {queryClient} from '@freckle/classroom/ts/common/query-client'
import {resetAuthStore} from '@freckle/classroom/ts/store/auth'
import {resetCurrentCourseIdStore} from '@freckle/classroom/ts/store/current-course-id'

export function logout() {
  deleteSessionCookie().then(
    ({redirectUrl}) => {
      resetAfterSignout()

      if (redirectUrl !== undefined) {
        document.location.href = redirectUrl
      } else {
        document.location.assign(`https://${document.location.host}`)
      }
    },
    () => {
      displayNotification('error', 'Could not log you out at this time, please try again later.')
      console.error('Could not delete session cookie')
    }
  )
}

function resetAfterSignout() {
  // Drop all in-memory data (except language preference, from settingsStore)
  // so nothing survives for a restored page to show
  queryClient.clear()
  resetAuthStore()
  resetCurrentCourseIdStore()

  const intervalId = getRenaissanceKeepaliveIntervalId()
  if (intervalId !== null) {
    clearInterval(intervalId)
  }
}
